import { Alert, message } from 'antd';
import CardOperationsGrid from './operationGrid';
import Filters from './opearationfilter';
import apiCalls from 'src/api/apiCalls';
import { useEffect, useState, useRef, useCallback } from 'react';
import HeaderComponent from 'src/components/header';
const CardOperations = () => {
  const [opeationLu, setOpeationLu] = useState([]);
  const [filterValues, setFilterValues] = useState({ "email": null, "cardnumber": null, cardStatus: null, startDate: null, endDate: null });
  const [isExcelExport, setIsExcelExport] = useState(false);
  const [error, setError] = useState(null);
  const shouldLog = useRef(true);
  const refreshRef = useRef();
  const [isRefresh, setIsRefresh] = useState(false);
  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      getOpearationLuData();
    }
  }, [])
  const getOpearationLuData = async () => {
    try {
      const response = await apiCalls.getCardsLookups('TradeStatusLu');
      if (response) {
        setOpeationLu(response.data?.TradeStatus)
        setError(null)
      }
      else {
        setError(apiCalls.isErrorDispaly(response))
      }
    }
    catch (error) {
      setError(apiCalls.isErrorDispaly(error))
    }
  }
  const handleSearch = useCallback((values) => {
    let _dates = values.dateRange
      ? values.dateRange.map(date => date.format('YYYY-MM-DD'))
      : null;
    setFilterValues({
      email: values?.email || null,
      cardNumber: values?.cardNumber || null,
      cardStatus: values?.opeationStatus || null,
      startDate: _dates ? _dates[0] : null,
      toDate: _dates ? _dates[1] : null
    });
  }, []);
  const handleExcelExport = useCallback(() => {
    setIsExcelExport(true);
    setTimeout(() => {
      setIsExcelExport(false)
    });
    message.destroy();
    message.success({
      content: 'Download Excel Successfully',
      className: 'custom-msg',
      duration: 3
    });
  }, [])
  const breadCrumbList = [
    { bname: 'Card Activity' },
  ]
  const refreshCallBack = useCallback(() => {
    setIsRefresh(false);
  }, [])
  const closeError = useCallback(() => {
    setError()
  }, [])
  return (
    <div className=''>
      <HeaderComponent breadCrumbList={breadCrumbList} />
      {error &&
        <div className='mb-4'>
          <Alert
            className='mb-6'
            type="error"
            description={error}
            onClose={closeError}
            showIcon
            closable
          />
        </div>
      }
      <Filters handleExcelExport={handleExcelExport} opeationLu={opeationLu} filterObj={handleSearch} filterValues={filterValues} onloadGrid={refreshRef?.current?.loadGrid} />
      <div className=''>
        <CardOperationsGrid filterValues={filterValues} isExcelExport={isExcelExport} isRefresh={isRefresh} refreshCallBack={refreshCallBack} />
      </div>
    </div>
  )
}
export default CardOperations;